import React, { useEffect, useState } from 'react';
import { adminApi } from '../../services/adminApi';

const fmt = (iso) => (iso ? new Date(iso).toLocaleString() : '—');
const LABEL = { red: 'Not ready', amber: 'Attention', green: 'Ready', grey: 'Not assessed' };

// Super admin: readiness change emails held after a deploy, and the changes logged instead.
export const ReadinessEmailHoldCard = () => {
  const [data, setData] = useState(null);
  const load = () => adminApi.readinessEmailHold().then(r => setData(r.data)).catch(() => setData({ hold: null, held_changes: [] }));
  useEffect(() => { load(); }, []);
  if (!data) return null;
  const h = data.hold;
  const toggle = () => (h?.active ? adminApi.endReadinessEmailHold() : adminApi.startReadinessEmailHold('manual')).then(load);
  return (
    <section className="space-y-3" data-testid="readiness-email-hold-card">
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <h2 className="text-sm uppercase tracking-widest text-muted-foreground">Readiness email hold</h2>
        <button onClick={toggle} className="text-xs border border-border rounded-sm px-2 py-1 hover:bg-secondary/60 transition-colors" data-testid="readiness-email-hold-toggle">
          {h?.active ? 'End hold now' : 'Start 2-hour hold'}
        </button>
      </div>
      <p className="text-xs text-muted-foreground" data-testid="readiness-email-hold-status">
        {h?.active
          ? `ON since ${fmt(h.started_at)} (${h.reason}). Ends after the first full recalculation, or at ${fmt(h.expires_at)}. ${h.held_changes || 0} change(s) held.`
          : h ? `Off. Last hold ${fmt(h.started_at)} to ${fmt(h.ended_at)} (${h.ended_reason}), ${h.held_changes || 0} change(s) held.` : 'No hold has been set.'}
      </p>
      <HeldChanges rows={data.held_changes} />
    </section>
  );
};

const HeldChanges = ({ rows }) => (
  <div className="rounded-md border border-border overflow-x-auto">
    <table className="w-full text-sm min-w-[560px]">
      <thead className="bg-secondary/40 border-b border-border">
        <tr className="text-[10px] uppercase tracking-widest text-muted-foreground">
          <th className="text-left px-3 py-2">When</th><th className="text-left px-3 py-2">Company</th>
          <th className="text-left px-3 py-2">Unit</th><th className="text-left px-3 py-2">Change (not emailed)</th>
        </tr>
      </thead>
      <tbody>
        {rows.length === 0 && <tr><td colSpan={4} className="px-3 py-3 text-xs text-muted-foreground" data-testid="held-changes-empty">No held changes in the last 14 days.</td></tr>}
        {rows.map(e => (
          <tr key={e.id} className="border-b border-border last:border-0" data-testid={`held-change-${e.id}`}>
            <td className="px-3 py-2 font-mono text-xs">{fmt(e.at)}</td>
            <td className="px-3 py-2 text-xs">{e.company || e.tenant_id}</td>
            <td className="px-3 py-2 text-xs">{e.unit_number || e.asset_id}</td>
            <td className="px-3 py-2 text-xs">{LABEL[e.from_status] || e.from_status} → {LABEL[e.to_status] || e.to_status}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);
